/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportTag } from '../models/ReportTag';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReportTagService {

    /**
     * Get list of report tags
     * @returns ReportTag Success
     * @throws ApiError
     */
    public static getReportTags({
        name,
    }: {
        /**
         * Search
         */
        name?: string,
    }): CancelablePromise<Array<ReportTag>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/reportTag',
            query: {
                'name': name,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
